import "./UpdateRequests.css";
import { Card, Tags, Paperclip, Phone, Landmark, RefreshCcw, FileText } from "../../../ui";
import { formatDate } from "../../utils/ludDocuments.helpers";

const TYPES = {
  contact: { ar: "بيانات تواصل", en: "Contact details", icon: Phone },
  iban: { ar: "آيبان بنكي", en: "Bank IBAN", icon: Landmark },
  transfer: { ar: "نقل ملكية", en: "Ownership transfer", icon: RefreshCcw },
};

const STATUSES = {
  new: { ar: "جديد", en: "New", variant: "neutral" },
  in_progress: { ar: "جاري العمل", en: "In progress", variant: "warning" },
  done: { ar: "مكتمل", en: "Completed", variant: "success" },
  cancelled: { ar: "ملغي", en: "Cancelled", variant: "danger" },
};

export default function UpdateRequests({ restaurant, lang, uploadTarget, onUploadTargetChange }) {
  const ar = lang === "ar";

  if (!restaurant.updates.length) {
    return (
      <div className="lud-empty-note">
        {ar
          ? "لم يُرسل هذا المطعم أي طلب تحديث حتى الآن."
          : "This restaurant has not submitted any update requests yet."}
      </div>
    );
  }

  return (
    <div className="lud-updates">
      {restaurant.updates.map((request) => {
        // Unknown values from the server fall back to the raw value instead of crashing the page.
        const type = TYPES[request.type] || {
          ar: request.type || "—",
          en: request.type || "—",
          icon: FileText,
        };
        const status = STATUSES[request.status] || {
          ar: request.status || "—",
          en: request.status || "—",
          variant: "neutral",
        };
        const Icon = type.icon;
        return (
          <Card key={request.id} className={`lud-update-card ${uploadTarget?.type === request.type ? "is-selected" : ""}`} hoverable={false} onClick={() => onUploadTargetChange?.({ type: request.type })}>
            <div className="lud-updates__head">
              <div className="lud-updates__type">
                <span className="lud-updates__icon"><Icon size={17} /></span>
                <div>
                  <strong>{ar ? `تحديث ${type.ar}` : `Update ${type.en}`}</strong>
                  <small>
                    {ar ? "تاريخ الملف" : "File date"}: {formatDate(request.date, lang)}
                  </small>
                </div>
              </div>
              <Tags variant={status.variant}>{status[lang]}</Tags>
            </div>
            <div className="lud-updates__attachment">
              <Paperclip size={16} />
              {ar
                ? "المستند المتقدَّم به مرفق مع الطلب"
                : "The submitted document is attached to the request"}
            </div>
          </Card>
        );
      })}
    </div>
  );
}
